import React from 'react';
import communityImage from '../assets/image2.jpg';


//import gifBackground from '../assets/main1.gif';
const gifBackground = "https://ik.imagekit.io/confesz/main11.avif";


function Home() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Video Background Section */}
      <div className="relative min-h-screen">
        <div className="absolute inset-0 overflow-hidden">
        <img
            src={gifBackground}
            alt="Background animation"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black opacity-25"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 flex flex-col items-center justify-center min-h-screen text-center text-white px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-lg">
            Express Yourself Without Fear
          </h1>
        </div>
      </div>

      {/* Welcome Section */}
      <div className="bg-black text-white py-16 px-4 text-center">
        <h2 className="text-5xl md:text-5xl font-extrabold mb-4">Welcome to Confesz</h2>
        <p className="text-xl md:text-2xl font-medium">Free Social Media</p>
      </div>

      <div className="bg-black text-white py-16 px-4 text-center">
        <p className="text-lg">ConfesZ is a revolutionary mobile application designed to provide a free and open platform for everyone to share their experiences, stories, confessions, or anything else they want to talk about. Available for Android and iOS, ConfesZ offers a unique, self-moderated space where users can express themselves without any restrictions.</p>
      </div>

      {/* Divider */}
      <div className="h-0.5 bg-gray-900 w-full"></div>

      {/* Two-Column Information Section */}
      <div className="grid md:grid-cols-2 bg-black text-white">
        <div className="p-8">
          <h3 className="text-3xl font-bold mb-4">Open Platform:</h3>
          <p className="text-lg">
            Share anything you want, be it experiences, stories, or confessions. ConfesZ is your space to speak freely.
          </p>
        </div>
        <div className="p-8">
          <h3 className="text-3xl font-bold mb-4">Free and Self-Moderated:</h3>
          <p className="text-lg">
            Enjoy a platform that's free to use and moderated by the community, ensuring a positive and respectful environment for all.
          </p>
        </div>
        <div className="p-8">
          <h3 className="text-3xl font-bold mb-4">Temporary Posts:</h3>
          <p className="text-lg">
            All posts are automatically deleted after a few days, so you never have to worry about your past posts lingering indefinitely.
          </p>
        </div>
        <div className="p-8">
          <h3 className="text-3xl font-bold mb-4">Simple Sign-Up:</h3>
          <p className="text-lg">
            Signing up is incredibly easy. All you need is an active email address – no passwords required. Just enter your email, receive a code, and you're in!
          </p>
        </div>
      </div>

      {/* Image Section */}
      <div className="bg-black py-16 flex justify-center">
        <img 
          src={communityImage} 
          alt="Confesz Community" 
          className="w-full max-w-4xl rounded-lg shadow-lg"
        />
      </div>

      {/* Italic Text Section */}
      <div className="bg-black py-8 flex justify-center">
        <div className="bg-gray-800 p-6 rounded-lg max-w-3xl">
          <p className="text-xl italic text-gray-300 text-center whitespace-pre-line">
            {`"Join ConfesZ today and start sharing your voice with the world.
            Express yourself freely, connect with others, and be part of a community that values openness and authenticity"`}
          </p>
        </div>
      </div>

      {/* Spacer */}
      <div className="bg-black h-16"></div>
    </div>
  );
}

export default Home;